import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'lokos-progress',
    standalone: false,
    templateUrl: './progress.component.html',
    styleUrl: './progress.component.scss',
})
export class ProgressComponent {
    color = input.required<string>();
    progress = input.required<string | null>();

    progressValue = computed<number>(() => {
        const value = this.progress();
        if (!value) return 0;

        return Number(value.replace('%', '')) || 0;
    });
}
